module.exports = __webpack_public_path__ + "static/media/home-bg-7.fe377718.jpg";